import { useState, useEffect } from 'react';
import ScaleLoader from 'react-spinners/ScaleLoader';

import '../styles/loading.scss';

const color = '#CCCCCC';

interface Props {
  message?: string;
  hideRefreshMessage?: boolean;
  problemMessage?: string;
}

const LoadingPage = ({
  message = '',
  hideRefreshMessage = false,
  problemMessage = 'This is taking longer than normal. Try to refresh your browser.',
  ...rest
}: Props) => {
  const [deferred, setDeferred] = useState(true);
  const [problem, setProblem] = useState(false);

  useEffect(() => {
    const timers: any[] = [];
    timers.push(setTimeout(() => setDeferred(false), 200));
    timers.push(setTimeout(() => setProblem(true), 5 * 60 * 1000));

    return () => timers.forEach(timer => clearTimeout(timer));
  }, []);

  return (
    <div className="loading-wrapper" {...rest}>
      <div className="loading-child">
        {!deferred && <ScaleLoader color={color} />}
        {message && <div className="msg">{message}</div>}
        {problem && !hideRefreshMessage && <div>{problemMessage}</div>}
      </div>
    </div>
  );
};

export default LoadingPage;
